<template>
  <v-card class="elevation-0">
    <v-card-title>
      หนังสือขออนุมัติ <span v-if="academicYear" class="ml-2 primary--text">ภาคการศึกษาที่ {{ academicYear.semesterYear }}</span>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="ค้นหา ชื่อ, นามสกุล"
        single-line
        hide-details
        clearable
        v-model="pagination.q"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-select
        :items="statusItems"
        v-model="pagination.status"
        label="สถานะ"
        item-text="text"
        item-value="value"
        box
      ></v-select>
    </v-card-title>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.fullname }}</td>
        <td class="text-xs-center">{{ props.item.crousePlanDate | formatShortDate }}</td>
        <td class="text-xs-center">{{ props.item.subjectCode }}</td>
        <td class="text-xs-center">{{ props.item.courseType | courseType }}</td>
        <td class="text-xs-center">{{ props.item.authorizedPerson }}</td>
        <td class="text-xs-center">{{ props.item.letterStatus | requestStatus }}</td>
        <td class="text-xs-center">{{ props.item.letterReceivedDate | formatShortDate }}</td>
        <td>{{ props.item.letterRecipient.fullname }}</td>
        <td>
          <template v-if="allowedRoles">
            <v-icon
              small
              color="primary"
              class="mr-2"
              @click="editItem(props.item)"
              v-if="props.item.letterStatus === 'NEW' || props.item.letterStatus === 'APPROVED'" 
            >
              edit
            </v-icon>
            <v-icon
              color="green"
              class="mr-2"
              v-if="props.item.letterStatus === 'COMPLETED'" 
            >
              check_circle_outline
            </v-icon>
          </template>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ pagination.q }}" found no results.
      </v-alert>
    </v-data-table>
    <div class="text-xs-center pt-2">
      <v-pagination v-model="pagination.page" :length="pages" :total-visible="7"></v-pagination>
    </div>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="title">
          <v-icon
            class="mr-2"
          >
            edit
          </v-icon><span>{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <div v-if="processStatus === 'NEW'">
                  <v-switch
                    v-model="editedItem.letterStatus"
                    label="อนุมัติแล้ว"
                    color="success"
                    value="APPROVED"
                    hide-details
                  ></v-switch>
                </div>
                <div v-if="processStatus === 'APPROVED'">
                  <v-switch
                    v-model="editedItem.letterStatus"
                    label="รับแล้ว"
                    color="success"
                    value="COMPLETED"
                    hide-details
                  ></v-switch>
                </div>
              </v-flex>
            </v-layout>

            <v-expand-transition>
              <v-layout wrap v-if="editedItem.letterStatus === 'COMPLETED'">
                <v-flex xs12 sm12 md12>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu"
                    :nudge-top="30"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      :value="date(editedItem.letterReceivedDate)" 
                      label="วันที่รับ"
                      prepend-icon="event"
                      readonly
                      outline
                    ></v-text-field>
                    <v-date-picker 
                      v-model="editedItem.letterReceivedDate" 
                      no-title 
                      locale="th-Th"
                      @input="menu = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-autocomplete
                    :items="personItems"
                    v-model="editedItem.letterRecipient"
                    item-value="id"
                    item-text="fullname"
                    label="ผู้รับ"
                    prepend-icon="person"
                    outline
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-expand-transition>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey white--text" @click.native="close">ยกเลิก</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" dark @click.native="save">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import swal from 'sweetalert2'

export default {
  props: ['academicYear', 'personItems', 'allowedRoles'],
  data () {
    return {
      dialog: false,
      menu: false,
      loading: false,
      headers: [
        { text: 'ชื่อ-นามสกุล', align: 'left', sortable: true, value: 'fullname'}, 
        { text: 'วันที่มา', align: 'center', sortable: true, value: 'crousePlanDate'},
        { text: 'วิชา', align: 'center', sortable: false, value: 'subjectCode'},
        { text: 'หลักสูตร', align: 'center', sortable: false, value: 'courseType'}, 
        { text: 'ผู้บังคับบัญชา', align: 'center', sortable: false, value: 'authorizedPerson'},
        { text: 'สถานะ', align: 'center', sortable: true, value: 'letterStatus'}, 
        { text: 'วันที่รับ', align: 'center', sortable: false, value: 'letterReceivedDate'}, 
        { text: 'ผู้รับ', align: 'left', sortable: false, value: 'letterRecipient.fullname'}, 
        { text: '', sortable: false} 
      ],
      statusItems: [
        { text: 'ทั้งหมด', value: '' },
        { text: 'คำร้องใหม่', value: 'NEW' }, 
        { text: 'อนุมัติแล้ว', value: 'APPROVED' }, 
        { text: 'รับแล้ว', value: 'COMPLETED' }
      ],
      items: [],
      pagination: {
        q: '',
        sortBy: 'letterStatus',
        descending: true,
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
        academicYear: this.academicYear.id,
        type: 'letter',
        status: ''
      },
      editedIndex: -1,
      editedItem: {
        letterStatus: '',
        letterReceivedDate: null,
        letterRecipient: null
      },
      defaultItem: {
        letterStatus: '',
        letterReceivedDate: null,
        letterRecipient: null
      },
      processStatus: null
    }
  },
  mounted () {
    // console.log('DataTableLetter mounted...')
    this.reload()
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : `ดำเนินการ ${this.editedItem.fullname}`
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  methods: {
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 200)
      this.reload()
    },
    date (val) {
      return this.$options.filters.formatFullDate(val)
    },
    editItem (item) {
      // console.log('editItem', item)
      this.processStatus = item.letterStatus
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    save () {
      // console.log('save called...', this.editedItem)
      this.$store.dispatch('instructor/update', this.editedItem)
        .then((response) => {
          // console.log('onSave:', response )
          this.loading = false
          swal({
            title: 'Success!',
            type: 'success'
          }).then(response => {
            this.close()
          })
        }).catch((error) => {
          this.loading = false
          swal('Error!', error.message, 'error')
        })
    },
    reload () {
      // console.log('reload called...')
      this.loading = true
      this.$store.dispatch("instructor/loadItemsAsPage", this.pagination)
        .then((response) => {
          this.pagination.totalItems = response.data.totalItems
          this.items = response.data.items
          // console.log('items', this.items)
          this.loading = false
        }).catch((error)=>{
          console.log('reload', error)
          this.loading = false
          swal('Error!', error.message, 'error')
        })
    },
  },
  watch: {
    pagination: {
      handler () {
        this.reload()
      },
      deep: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/instructor/dataTables/dataTableLetter.vue